import { EvaChartStates } from "types/factory";

import { convertToNumber } from "./utils/convertToNumber";

export function materialBalanceTimeLocks(states: Partial<EvaChartStates>) {
  const { locks } = states;
  const lockedYMin = locks?.yMin?.value;
  const lockedYMax = locks?.yMax?.value;
  const lockedXMax = locks?.xMax?.value;
  const lockedXMin = locks?.xMin?.value;

  return {
    lockedXMin: convertToNumber(lockedXMin),
    lockedXMax: convertToNumber(lockedXMax),
    lockedYMin: convertToNumber(lockedYMin),
    lockedYMax: convertToNumber(lockedYMax)
  };
}
